import { CSSResultArray } from 'lit';
import host from '@maersk-global/mds-components-utils/host/host.styles.js';
import tokens from '@maersk-global/mds-design-tokens/implementation/core/button-group/js/design-tokens-px.css.js';
import style from './mc-button-group.scss';
export const styles: CSSResultArray = [host, style, tokens];
